import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import TextTruncate from 'react-text-truncate'

import Icon from 'Pods/Shared/Icon/Icon'
import ImageSorting from 'Pods/Shared/ImageSorting/ImageSorting'

const Embed = ({
  id, url, imageProps, onRemove,
}) => {
  return (
    <Fragment>
      <div className="image-wrapper">
        <div className="delete-image is-hidden-when-sortable">
          <span onClick={(e) => onRemove(e, id)}>
            <Icon type={['far', 'times']} className="ml-5 is-bigger" />
          </span>
        </div>
        <img src={url} />
      </div>
      <div className="image-container__title is-hidden-when-sortable">
        <small>
          <div className="text-semibold text-capitalize">{imageProps.type}</div>
          <TextTruncate text={imageProps.title} truncateText="…" line={1} />
        </small>
      </div>
    </Fragment>
  )
}

const dropSpace = (
  <div className="col-12 col-sm-4 col-md-3 u-mb10">
    <div className="image-container is-placeholder">
      <div className="image-wrapper">&nbsp;</div>
    </div>
  </div>
)

class EmbedsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      embeds: props.embeds,
      selectedEmbedsIds: [],
    }

    this.onSelectionChange = this.onSelectionChange.bind(this)
    this.onEmbedClick = this.onEmbedClick.bind(this)
    this.removeEmbed = this.removeEmbed.bind(this)
    this.onRemoveEmbed = this.onRemoveEmbed.bind(this)
    this.onSortEnd = this.onSortEnd.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.embeds !== this.props.embeds) {
      this.setState({ embeds: this.props.embeds })
    }
  }

  onSelectionChange(selectedEmbedsIds) {
    this.setState({ selectedEmbedsIds })
  }

  onEmbedClick(id) {
    let selected = this.state.selectedEmbedsIds

    if (selected.includes(id)) {
      selected = selected.filter(selectedId => selectedId !== id)
    } else {
      selected.push(id)
    }

    this.setState({ selectedEmbedsIds: selected })
  }

  removeEmbed(e, id) {
    e.stopPropagation()

    return axios.delete(`/api/internal/items/${this.props.itemId}/embeds/${id}`)
      .then((response) => { this.onRemoveEmbed(id) })
      .catch((xhr) => { App.events.publish('app:notification:flash:error', xhr.response.statusText) })
  }

  onRemoveEmbed(id) {
    const newEmbeds = this.state.embeds.filter(embed => embed.id !== id)

    this.setState({ embeds: newEmbeds })

    this.props.onChange(newEmbeds)
  }

  onSortEnd(newEmbedsOrder) {
    const sortedEmbeds = newEmbedsOrder.map((embedId) => {
      return this.state.embeds.find((embed) => embed.id === embedId)
    })

    this.setState({ embeds: sortedEmbeds })

    this.props.onChange(sortedEmbeds)
  }

  render() {
    return (
      <div className="section__embeds sortable-images-list sortable-image-list--contained">
        <ImageSorting
          key={this.state.embeds}
          className="row"
          images={this.state.embeds.map((data) => ({
            id: data.id, url: data.url, type: data.type, title: data.title,
          }))}
          imageComponent={Embed}
          onDragStateChange={this.props.onDragStateChange}
          onChange={this.onSortEnd}
          onSelectionChange={this.onSelectionChange}
          onRemove={this.removeEmbed}
          spaceComponent={dropSpace}
          containerSizes="col-12 col-sm-4 col-md-3"
        />
      </div>
    )
  }
}

EmbedsList.propTypes = {
  itemId: PropTypes.number.isRequired,
  embeds: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  onDragStateChange: PropTypes.func.isRequired,
}

export default EmbedsList
